import type { StringKey } from './i18n'

/**
 * The decisions behind "Remove from class" and "Mute all students", kept free of
 * React and the network so they can be tested on their own.
 */

/**
 * Only a learner can be removed. Meetings::Moderation refuses Parent:, Ghost:
 * and Tutor: targets with a 403, so offering the control on them would only
 * produce an error.
 */
export function canRemove(identity: string): boolean {
  return identity.startsWith('Student:')
}

/**
 * `status` is undefined when the request never got an HTTP answer (offline, DNS,
 * or the request timeout). 404 is the server saying the target already left.
 */
export function moderationFailureKey(status: number | undefined): StringKey {
  if (status === undefined) return 'moderate.offline'
  if (status === 404) return 'moderate.notInClass'
  if (status === 403) return 'moderate.notAllowed'
  return 'moderate.failed'
}

/** `muted` is the server's count. Zero is worth saying: nothing changed. */
export function muteAllKey(muted: unknown): StringKey {
  return muted === 0 ? 'moderate.mutedNone' : 'moderate.mutedAll'
}
